<style>
#processRegister .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 600px !important;
}
#processRegister .modal__footer {
  display: none !important;
}
</style>

<template>
  <Modal
    modalName="processRegister"
    title="Rejestr procesów inwestycyjnych"
    :buttons="[]"
  >
    <ProcessTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import ProcessTable from "../../table/investments/ProcessTable.vue";

export default {
  components: {
    Modal,
    ProcessTable
  },
  data: () => ({
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/ProcessRegister.vue